import { chakra, Grid, Flex } from "@chakra-ui/react"
import { colours } from "@shared/ui.design-system"

export const Container = chakra(Grid, {
  baseStyle: {
    w: "full",
    backgroundImage: {
      base: "url('/images/gift-membership/gift-membership-mobile.jpg')",
      md: "url('/images/gift-membership/gift-membership-desktop.jpg')",
    },
    backgroundColor: colours.accent.light,
    backgroundSize: {
      base: "contain",
      md: "cover",
    },
    backgroundRepeat: "no-repeat",
    gridTemplateColumns: {
      base: "1fr",
      md: "1fr 10fr 1fr",
    },
  },
})

export const GridContent = chakra(Grid, {
  baseStyle: {
    w: "full",
    gridColumn: {
      base: "1",
      md: "2",
    },
    gridTemplateColumns: {
      base: "1fr",
      md: "1fr 1fr",
    },
  },
})

export const Content = chakra(Flex, {
  baseStyle: {
    gridColumn: {
      base: "1 / -1",
      md: "1 / 1",
    },
    w: "full",
    flexDirection: "column",
    textAlign: "center",
    py: 5,
    px: -4,
    pt: {
      base: "450px",
      md: 3,
    },
  },
})
